import { showSpinner, hideSpinner } from "store/slices/spinner";
import {
  getDistrictList,
  getStoreNoList,
  getlaborCodeList,
  getstatusList,
  updatePricingService,
  searchSubmitService,
  approveRejectService,
  verifyCurrentRatesService,
  getExceptionPricesList,
  addExceptionPrice,
  editPriceService,
  deletePriceService,
  showExpPriceService,
} from "services/laborTable.service";

import {
  updateSearchFilterValue as updateSearchFilterValueAction,
  getDistrictList as getDistrictListAction,
  getStoreNoList as getStoreNoListAction,
  getLaborCodeList as getLaborCodeListAction,
  getStatusList as getStatusListAction,
  updateSearchFields as updateSearchFieldsAction,
  clearCustomerFields as clearCustomerFieldsAction,
  customerRowSelection as customerRowSelectionAction,
  selectAll as selectAllAction,
  resetSelectedRows as resetSelectedRowsAction,
  searchSubmit as searchSubmitAction,
  searchSubmitSuccess,
  searchSubmitFailure,
  updatePricingData,
  approveRejectPricing as approveRejectPricingAction,
  getExcepPrices as getExcepPricesAction,
  updateExpSearchData,
  showExpPrice as showExpPriceAction,
} from "store/slices/laborTable";

export const updateSearchFilterValue = (payload) => (dispatch) => {
  dispatch(updateSearchFilterValueAction(payload));
};

export const getDistrictOptions = () => (dispatch) => {
  getDistrictList().then((response) => {
    dispatch(getDistrictListAction(response));
  });
};
export const getStoreNoOptions = () => (dispatch) => {
  getStoreNoList().then((response) => {
    dispatch(getStoreNoListAction(response));
  });
};
export const getlaborCodeOptions = () => (dispatch) => {
  getlaborCodeList().then((response) => {
    dispatch(getLaborCodeListAction(response));
  });
};
export const getstatusOptions = () => (dispatch) => {
  getstatusList().then((response) => {
    dispatch(getStatusListAction(response));
  });
};

export const updateSearchFields = (key, value) => (dispatch) => {
  dispatch(updateSearchFieldsAction({ key, value }));
};

export const clearCustomerFields = () => (dispatch) => {
  dispatch(clearCustomerFieldsAction());
};

export const CustomerRowSelection = (id) => (dispatch) => {
  dispatch(customerRowSelectionAction(id));
};

export const SelectAll = (data) => (dispatch) => {
  dispatch(selectAllAction(data));
};

export const resetSelectedRows = () => (dispatch) => {
  dispatch(resetSelectedRowsAction());
};

export const searchSubmit = (data) => async (dispatch) => {
  dispatch(searchSubmitAction());
  dispatch(showSpinner());
  return searchSubmitService(data)
    .then((res) => {
      const updatedRes = res.map((item, index) => {
        item.elementIndex = index;
        item.isSelected = false;
        item.approvedBy = !item.approvedBy || item.approvedBy == "null" ? " " : item.approvedBy;
        item.accountNumber = item.exceptionPrice === "1" ? item.accountNumber : "";
        item.createdTimestamp =
          !item.createdTimestamp || item.createdTimestamp == "null"
            ? " "
            : new Date(item.createdTimestamp).toLocaleDateString("en-US");
        item.updatedTimeStamp =
          !item.updatedTimeStamp || item.updatedTimeStamp == "null"
            ? " "
            : new Date(item.updatedTimeStamp).toLocaleDateString("en-US");
        item.installerPayRateNew =
          !item.installerPayRateNew || isNaN(item.installerPayRateNew) || item.installerPayRateNew === null
            ? "NP"
            : item.installerPayRateNew;
        item.laborBillRateNew =
          !item.laborBillRateNew || isNaN(item.laborBillRateNew) || item.laborBillRateNew === null
            ? "NP"
            : item.laborBillRateNew;
        item.verificationDate =
          !item.verificationTime || item.verificationTime == "null"
            ? " "
            : new Date(item.verificationTime).toLocaleDateString("en-US");
        item.installerPayRate =
          !item.installerPayRate || isNaN(item.installerPayRate) || item.installerPayRate === null
            ? "NP"
            : parseFloat(item.installerPayRate).toFixed(2).toString();
        item.laborBillRate =
          !item.laborBillRate || isNaN(item.laborBillRate) || item.laborBillRate === null
            ? "NP"
            : parseFloat(item.laborBillRate).toFixed(2).toString();
        item.standardInstallerPayRate =
          !item.standardInstallerPayRate ||
          isNaN(item.standardInstallerPayRate) ||
          item.standardInstallerPayRate === null
            ? "0.00"
            : parseFloat(item.standardInstallerPayRate).toFixed(2).toString();
        item.standardLaborBillRate =
          !item.standardLaborBillRate || isNaN(item.standardLaborBillRate) || item.standardLaborBillRate === null
            ? "0.00"
            : parseFloat(item.standardLaborBillRate).toFixed(2).toString();

        const newPercentVal = (
          ((item.laborBillRateNew - item.installerPayRateNew) / item.laborBillRateNew) *
          100
        ).toFixed(1);
        item.percentReturnNew = isNaN(newPercentVal) ? "N/A" : newPercentVal + "%";

        if (["1", "0"].includes(item.exceptionPrice)) {
          const percentVal = (((item.laborBillRate - item.installerPayRate) / item.laborBillRate) * 100).toFixed(1);
          item.percentReturn = isNaN(percentVal) ? "N/A" : percentVal + "%";
        }
        return item;
      });
      dispatch(searchSubmitSuccess(updatedRes));
      dispatch(hideSpinner());
    })
    .catch((err) => {
      dispatch(searchSubmitFailure(err));
      dispatch(hideSpinner());
    });
};

export const editPricingRates = (data, eleIndex) => async (dispatch) => {
  dispatch(showSpinner());
  return updatePricingService(data)
    .then((res) => {
      res.elementIndex = eleIndex;
      res.isSelected = false;
      res.accountNumber = res.exceptionPrice === "1" ? res.accountNumber : "";
      const percentVal = (((res.laborBillRate - res.installerPayRate) / res.laborBillRate) * 100).toFixed(1);
      res.percentReturn = isNaN(percentVal) ? "N/A" : percentVal + "%";
      const newPercentVal = (((res.laborBillRateNew - res.installerPayRateNew) / res.laborBillRateNew) * 100).toFixed(
        1,
      );
      res.percentReturnNew = isNaN(newPercentVal) ? "N/A" : newPercentVal + "%";
      res.installerPayRate =
        !res.installerPayRate || isNaN(res.installerPayRate) || res.installerPayRate === null
          ? "NP"
          : res.installerPayRate;
      res.laborBillRate =
        !res.laborBillRate || isNaN(res.laborBillRate) || res.laborBillRate === null ? "NP" : res.laborBillRate;
      res.installerPayRateNew =
        !res.installerPayRateNew || isNaN(res.installerPayRateNew) || res.installerPayRateNew === null
          ? "NP"
          : res.installerPayRateNew;
      res.laborBillRateNew =
        !res.laborBillRateNew || isNaN(res.laborBillRateNew) || res.laborBillRateNew === null
          ? "NP"
          : res.laborBillRateNew;
      res.verificationTime = !res.verificationTime
        ? "null"
        : new Date(res.verificationTime).toLocaleDateString("en-US");
      res.createdTimestamp =
        !res.createdTimestamp || res.createdTimestamp == "null"
          ? " "
          : new Date(res.createdTimestamp).toLocaleDateString("en-US");
      res.updatedTimeStamp =
        !res.updatedTimeStamp || res.updatedTimeStamp == "null"
          ? " "
          : new Date(res.updatedTimeStamp).toLocaleDateString("en-US");
      res.verificationDate =
        !res.verificationTime || res.verificationTime == "null"
          ? " "
          : new Date(res.verificationTime).toLocaleDateString("en-US");
      res.approvedBy = !res.approvedBy || res.approvedBy == "null" ? " " : res.approvedBy;
      dispatch(updatePricingData(res));
      dispatch(hideSpinner());
      return res;
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(hideSpinner());
    });
};

export const approveRejectPricing = (data, records) => async (dispatch) => {
  dispatch(showSpinner());
  return approveRejectService(data)
    .then((res) => {
      res.map((editedrows) => {
        records.some((ele) => {
          if (ele.laborCodeStoreId === editedrows.laborCodeStoreId) {
            editedrows.elementIndex = ele.elementIndex;
            editedrows.isSelected = false;
            editedrows.accountNumber = editedrows.exceptionPrice === "1" ? editedrows.accountNumber : "";
            const percentVal = (
              ((editedrows.laborBillRate - editedrows.installerPayRate) / editedrows.laborBillRate) *
              100
            ).toFixed(1);
            editedrows.percentReturn = isNaN(percentVal) ? "N/A" : percentVal + "%";
            const newPercentVal = (
              ((editedrows.laborBillRateNew - editedrows.installerPayRateNew) / editedrows.laborBillRateNew) *
              100
            ).toFixed(1);
            editedrows.percentReturnNew = isNaN(newPercentVal) ? "N/A" : newPercentVal + "%";
            editedrows.installerPayRate =
              !editedrows.installerPayRate || isNaN(editedrows.installerPayRate) || editedrows.installerPayRate === null
                ? "NP"
                : editedrows.installerPayRate;
            editedrows.laborBillRate =
              !editedrows.laborBillRate || isNaN(editedrows.laborBillRate) || editedrows.laborBillRate === null
                ? "NP"
                : editedrows.laborBillRate;
            editedrows.installerPayRateNew =
              !editedrows.installerPayRateNew ||
              isNaN(editedrows.installerPayRateNew) ||
              editedrows.installerPayRateNew === null
                ? "NP"
                : editedrows.installerPayRateNew;
            editedrows.laborBillRateNew =
              !editedrows.laborBillRateNew || isNaN(editedrows.laborBillRateNew) || editedrows.laborBillRateNew === null
                ? "NP"
                : editedrows.laborBillRateNew;
            editedrows.createdTimestamp =
              !editedrows.createdTimestamp || editedrows.createdTimestamp == "null"
                ? " "
                : new Date(editedrows.createdTimestamp).toLocaleDateString("en-US");
            editedrows.updatedTimeStamp =
              !editedrows.updatedTimeStamp || editedrows.updatedTimeStamp == "null"
                ? " "
                : new Date(editedrows.updatedTimeStamp).toLocaleDateString("en-US");
            editedrows.verificationDate =
              !editedrows.verificationTime || editedrows.verificationTime == "null"
                ? " "
                : new Date(editedrows.verificationTime).toLocaleDateString("en-US");
            editedrows.approvedBy =
              !editedrows.approvedBy || editedrows.approvedBy == "null" ? " " : editedrows.approvedBy;
          }
          return ele.laborCodeStoreId === editedrows.laborCodeStoreId;
        });
      });
      dispatch(resetSelectedRowsAction());
      dispatch(approveRejectPricingAction(res));
      dispatch(hideSpinner());
    })
    .catch((err) => {
      dispatch(hideSpinner());
    });
};

export const verifyCurrentRates = (storeNum, searchData) => async (dispatch) => {
  dispatch(showSpinner());
  return verifyCurrentRatesService(storeNum)
    .then((result) => {
      return searchSubmitService(searchData)
        .then((res) => {
          const updatedRes = res.map((item, index) => {
            item.elementIndex = index;
            item.isSelected = false;
            item.approvedBy = !item.approvedBy || item.approvedBy == "null" ? " " : item.approvedBy;
            item.accountNumber = item.exceptionPrice === "1" ? item.accountNumber : "";
            item.createdTimestamp =
              !item.createdTimestamp || item.createdTimestamp == "null"
                ? " "
                : new Date(item.createdTimestamp).toLocaleDateString("en-US");
            item.updatedTimeStamp =
              !item.updatedTimeStamp || item.updatedTimeStamp == "null"
                ? " "
                : new Date(item.updatedTimeStamp).toLocaleDateString("en-US");
            item.installerPayRateNew =
              !item.installerPayRateNew || isNaN(item.installerPayRateNew) || item.installerPayRateNew === null
                ? "NP"
                : item.installerPayRateNew;
            item.laborBillRateNew =
              !item.laborBillRateNew || isNaN(item.laborBillRateNew) || item.laborBillRateNew === null
                ? "NP"
                : item.laborBillRateNew;
            item.verificationDate =
              !item.verificationTime || item.verificationTime == "null"
                ? " "
                : new Date(item.verificationTime).toLocaleDateString("en-US");
            item.installerPayRate =
              !item.installerPayRate || isNaN(item.installerPayRate) || item.installerPayRate === null
                ? "NP"
                : parseFloat(item.installerPayRate).toFixed(2).toString();
            item.laborBillRate =
              !item.laborBillRate || isNaN(item.laborBillRate) || item.laborBillRate === null
                ? "NP"
                : parseFloat(item.laborBillRate).toFixed(2).toString();
            item.standardInstallerPayRate =
              !item.standardInstallerPayRate ||
              isNaN(item.standardInstallerPayRate) ||
              item.standardInstallerPayRate === null
                ? "0.00"
                : parseFloat(item.standardInstallerPayRate).toFixed(2).toString();
            item.standardLaborBillRate =
              !item.standardLaborBillRate || isNaN(item.standardLaborBillRate) || item.standardLaborBillRate === null
                ? "0.00"
                : parseFloat(item.standardLaborBillRate).toFixed(2).toString();

            const newPercentVal = (
              ((item.laborBillRateNew - item.installerPayRateNew) / item.laborBillRateNew) *
              100
            ).toFixed(1);
            item.percentReturnNew = isNaN(newPercentVal) ? "N/A" : newPercentVal + "%";

            if (item.exceptionPrice === "1") {
              const percentVal = (((item.laborBillRate - item.installerPayRate) / item.laborBillRate) * 100).toFixed(1);
              item.percentReturn = isNaN(percentVal) ? "N/A" : percentVal + "%";
            } else if (item.exceptionPrice === "0") {
              item.installerPayRate = item.standardInstallerPayRate;
              const percentVal = (((item.laborBillRate - item.installerPayRate) / item.laborBillRate) * 100).toFixed(1);
              item.percentReturn = isNaN(percentVal) ? "N/A" : percentVal + "%";
            }
            return item;
          });
          dispatch(searchSubmitSuccess(updatedRes));
          dispatch(hideSpinner());
          return result;
        })
        .catch((err) => {
          dispatch(searchSubmitFailure(err));
          dispatch(hideSpinner());
        });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(hideSpinner());
    });
};

export const getExcepPrices = (data) => (dispatch) => {
  dispatch(showSpinner());
  return getExceptionPricesList(data)
    .then((res) => {
      res.map((item) => {
        item.exceptionPrice = !item.exceptionPrice ? "0" : parseFloat(item.exceptionPrice).toFixed(2).toString();
        item.installerRate = !item.installerRate ? "0" : parseFloat(item.installerRate).toFixed(2).toString();
        item.standardBillRate = !item.standardBillRate ? "0" : parseFloat(item.standardBillRate).toFixed(2).toString();
        item.standardInstallerRate = !item.standardInstallerRate
          ? "0"
          : parseFloat(item.standardInstallerRate).toFixed(2).toString();
      });
      dispatch(getExcepPricesAction(res));
      dispatch(hideSpinner());
      return res;
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(hideSpinner());
    });
};

export const addExcepPrice = (data, searchPayload) => async (dispatch) => {
  dispatch(showSpinner());
  return addExceptionPrice(data)
    .then((result) => {
      return getExceptionPricesList(searchPayload)
        .then((res) => {
          res.map((item) => {
            item.exceptionPrice = !item.exceptionPrice ? "0" : parseFloat(item.exceptionPrice).toFixed(2).toString();
            item.installerRate = !item.installerRate ? "0" : parseFloat(item.installerRate).toFixed(2).toString();
            item.standardBillRate = !item.standardBillRate
              ? "0"
              : parseFloat(item.standardBillRate).toFixed(2).toString();
            item.standardInstallerRate = !item.standardInstallerRate
              ? "0"
              : parseFloat(item.standardInstallerRate).toFixed(2).toString();
          });
          dispatch(getExcepPricesAction(res));
          dispatch(hideSpinner());
          return res;
        })
        .catch((err) => {
          console.log("err", err);
          dispatch(hideSpinner());
        });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(hideSpinner());
    });
};

export const editPrice = (data, searchPayload) => async (dispatch) => {
  dispatch(showSpinner());
  return editPriceService(data)
    .then((result) => {
      return getExceptionPricesList(searchPayload)
        .then((res) => {
          res.map((item) => {
            item.exceptionPrice = !item.exceptionPrice ? "0" : parseFloat(item.exceptionPrice).toFixed(2).toString();
            item.installerRate = !item.installerRate ? "0" : parseFloat(item.installerRate).toFixed(2).toString();
            item.standardBillRate = !item.standardBillRate
              ? "0"
              : parseFloat(item.standardBillRate).toFixed(2).toString();
            item.standardInstallerRate = !item.standardInstallerRate
              ? "0"
              : parseFloat(item.standardInstallerRate).toFixed(2).toString();
          });
          dispatch(getExcepPricesAction(res));
          dispatch(hideSpinner());
          return res;
        })
        .catch((err) => {
          console.log("err", err);
          dispatch(hideSpinner());
        });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(hideSpinner());
    });
};

export const editExpPrice = (data, searchData) => async (dispatch) => {
  dispatch(showSpinner());
  return editPriceService(data)
    .then((result) => {
      return searchSubmitService(searchData)
        .then((res) => {
          const updatedRes = res.map((item, index) => {
            item.elementIndex = index;
            item.isSelected = false;
            item.approvedBy = !item.approvedBy || item.approvedBy == "null" ? " " : item.approvedBy;
            item.accountNumber = item.exceptionPrice === "1" ? item.accountNumber : "";
            item.createdTimestamp =
              !item.createdTimestamp || item.createdTimestamp == "null"
                ? " "
                : new Date(item.createdTimestamp).toLocaleDateString("en-US");
            item.updatedTimeStamp =
              !item.updatedTimeStamp || item.updatedTimeStamp == "null"
                ? " "
                : new Date(item.updatedTimeStamp).toLocaleDateString("en-US");
            item.installerPayRateNew =
              !item.installerPayRateNew || isNaN(item.installerPayRateNew) || item.installerPayRateNew === null
                ? "NP"
                : item.installerPayRateNew;
            item.laborBillRateNew =
              !item.laborBillRateNew || isNaN(item.laborBillRateNew) || item.laborBillRateNew === null
                ? "NP"
                : item.laborBillRateNew;
            item.verificationDate =
              !item.verificationTime || item.verificationTime == "null"
                ? " "
                : new Date(item.verificationTime).toLocaleDateString("en-US");
            item.installerPayRate =
              !item.installerPayRate || isNaN(item.installerPayRate) || item.installerPayRate === null
                ? "NP"
                : parseFloat(item.installerPayRate).toFixed(2).toString();
            item.laborBillRate =
              !item.laborBillRate || isNaN(item.laborBillRate) || item.laborBillRate === null
                ? "NP"
                : parseFloat(item.laborBillRate).toFixed(2).toString();
            item.standardInstallerPayRate =
              !item.standardInstallerPayRate ||
              isNaN(item.standardInstallerPayRate) ||
              item.standardInstallerPayRate === null
                ? "0.00"
                : parseFloat(item.standardInstallerPayRate).toFixed(2).toString();
            item.standardLaborBillRate =
              !item.standardLaborBillRate || isNaN(item.standardLaborBillRate) || item.standardLaborBillRate === null
                ? "0.00"
                : parseFloat(item.standardLaborBillRate).toFixed(2).toString();

            const newPercentVal = (
              ((item.laborBillRateNew - item.installerPayRateNew) / item.laborBillRateNew) *
              100
            ).toFixed(1);
            item.percentReturnNew = isNaN(newPercentVal) ? "N/A" : newPercentVal + "%";

            if (item.exceptionPrice === "1") {
              const percentVal = (((item.laborBillRate - item.installerPayRate) / item.laborBillRate) * 100).toFixed(1);
              item.percentReturn = isNaN(percentVal) ? "N/A" : percentVal + "%";
            } else if (item.exceptionPrice === "0") {
              item.installerPayRate = item.standardInstallerPayRate;
              const percentVal = (((item.laborBillRate - item.installerPayRate) / item.laborBillRate) * 100).toFixed(1);
              item.percentReturn = isNaN(percentVal) ? "N/A" : percentVal + "%";
            }
            return item;
          });
          dispatch(searchSubmitSuccess(updatedRes));
          dispatch(hideSpinner());
        })
        .catch((err) => {
          dispatch(searchSubmitFailure(err));
          dispatch(hideSpinner());
        });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(hideSpinner());
    });
};

export const deletePrice = (data, searchPayload) => async (dispatch) => {
  dispatch(showSpinner());
  return deletePriceService(data)
    .then((result) => {
      return getExceptionPricesList(searchPayload)
        .then((res) => {
          res.map((item) => {
            item.exceptionPrice = !item.exceptionPrice ? "0" : parseFloat(item.exceptionPrice).toFixed(2).toString();
            item.installerRate = !item.installerRate ? "0" : parseFloat(item.installerRate).toFixed(2).toString();
            item.standardBillRate = !item.standardBillRate
              ? "0"
              : parseFloat(item.standardBillRate).toFixed(2).toString();
            item.standardInstallerRate = !item.standardInstallerRate
              ? "0"
              : parseFloat(item.standardInstallerRate).toFixed(2).toString();
          });
          dispatch(getExcepPricesAction(res));
          dispatch(hideSpinner());
          return res;
        })
        .catch((err) => {
          console.log("err", err);
          dispatch(hideSpinner());
        });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(hideSpinner());
    });
};

export const updateExpSearchValues = (key, value) => (dispatch) => {
  dispatch(updateExpSearchData({ key, value }));
};

export const showExpPrice = (data) => (dispatch) => {
  showExpPriceService(data).then((response) => {
    let isShowExp = false;
    if (response === 0) {
      isShowExp = false;
    } else {
      isShowExp = true;
    }
    dispatch(showExpPriceAction(isShowExp));
  });
};
